import { IsBoolean, IsNotEmpty, IsOptional, IsString } from "class-validator";
import { Transform } from "class-transformer";

export class FindConversationDto {
  @IsString()
  @IsOptional()
  contractorId?: string;

  @IsString()
  @IsNotEmpty()
  userProfileId!: string;

  @IsBoolean()
  @IsOptional()
  @Transform(({ value }) => value === "true" || value === true)
  isAdmin?: boolean;
}
